/* 大喬（江東二喬） */
import { defineHero, U, P } from '../define.ts';

export default defineHero({
  id: 'daqiao', name: '大喬', sub: '江東二喬', faction: 'wu', role: '輔助', weapon: 'fan',
  look: { female: true, head: 'bun', robe: true, size: 0.96, fx: '#ffb3c8', c: { cloth: '#d97a90', sleeve: '#d97a90', armor: '#fff0f3', flower: '#ffffff', fan: '#ffe3ea' } },
  skills: [
    ['冰箭', 'passive', '普攻附帶寒氣，目標移速 -{20/30/40/50}% 1 秒。', { pv: { poison: { dps: 0, dur: 1, slow: [20, 30, 40, 50] } } }],
    ['沉寂術', 'trap', '指定區域內的敵人 {5/6/7/8} 秒無法施放技能。', { x: { k: 'zone', r: 180, dur: [5, 6, 7, 8], silence: true }, aim: P(560, 180), el: 'shadow' }],
    ['吸取生命', 'bolt', '8 秒內每秒奪取目標 {17/28/39/50} 生命轉給自己。', { x: { k: 'nuke', leech: { dps: [17, 28, 39, 50], dur: 8 } }, aim: U(400), el: 'shadow' }],
    ['迷惑術', 'command', '迷惑一名小兵或黃巾賊為己方作戰 120 秒（對武將無效）。冷卻 108/84/60 秒。', { x: { k: 'nuke', charm: 120, noHero: true }, aim: U(480), cd: [180, 140, 100] }],
  ],
});
